import type { ReactNode } from 'react';
import { classNames } from '~/utils/styles';
import { TOOLTIP_BUBBLE_CLASS_NAMES } from './tooltipBubbleClassNames';

interface TooltipBubbleProps {
  children: ReactNode;
  /** Adjusts the bubble to the box its library gives it, such as a fixed width. */
  className?: string;
}

/** The design-system tooltip bubble on its own, for tooltips another library shows and positions (e.g. AG Grid). */
export const TooltipBubble = ({ children, className }: TooltipBubbleProps) => (
  <div className={classNames(TOOLTIP_BUBBLE_CLASS_NAMES, className)}>{children}</div>
);
